var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"app-navigation-header"},[_c('AppNavigationHeaderDatePicker'),_vm._v(" "),_c('div',{staticClass:"new-event-today-view-section"},[(!_vm.isPublic)?_c('AppNavigationHeaderNewEvent'):_vm._e(),_vm._v(" "),_c('AppNavigationHeaderTodayButton'),_vm._v(" "),_c('AppNavigationHeaderViewMenu')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }